import React, { useContext } from "react";

// Global state
import { StateContext } from "../../AppStateContext";

// Material UI stuff
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Icon from "@material-ui/icons/Home";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";

const HomeIconContent = ({ handleClick, moduleName }) => {
  // Consuming state
  const state = useContext(StateContext);

  const StyledListItem = withStyles({
    root: {
      fontFamily: "Alegreya Sans, sans-serif",
      fontSize: "20px",
      color: state.theme === "dark" ? "#fa0171" : "#ffffff",
      textTransform: "capitalize",
    },
  })(ListItem);
  return (
    <StyledListItem
      button
      onClick={handleClick}
      id="HomeIcon"
      style={{ display: state.clientId === "wcs" ? "flex" : "none" }}
    >
      <ListItemIcon
        style={{ color: state.theme === "dark" ? "#fa0171" : "#ffffff" }}
      >
        {!state.isSidebarOpen ? (
          <Tooltip title="Home" placement="right">
            <Icon />
          </Tooltip>
        ) : (
          <Icon />
        )}
      </ListItemIcon>
      {moduleName}
    </StyledListItem>
  );
};

export default HomeIconContent;
